/*Edit thong tin ve nguon tin va tai nan, phuong tien bi nan */
import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import Grid from "@material-ui/core/Grid";
import Moment from "react-moment";
import PropTypes from "prop-types";
import SelectFilter from "react-select";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import { DataGrid } from "@material-ui/data-grid";
import MyLatLonEditor from "./LatLonEditor";
import "../sukien.css";

import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";

import moment from "moment";

import MyButton from "../MyButton";

const myLib = require("../../lib/MyLib");
const server = require("../../lib/server");
const sukienLayer = require("../../lib/SuKienDataLayer");
///////////////////////////////////////////////////////////////////
const defaultRecord = {
  DuocCuu_NguoiVN: 0,
  DuocCuu_NguoiNN: 0,
  DuocCuu_GhiChu: null,
  TrucTiep_NguoiVN: 0,
  TrucTiep_NguoiNN: 0,
  TrucTiep_GhiChu: null,
  GianTiep_NguoiVN: 0,
  GianTiep_NguoiNN: 0,
  GianTiep_GhiChu: null,
  BiThuong: 0,
  BiChet: 0,
  MatTich: 0,
  TrucTiep_PhuongTien: 0,
  GianTiep_PhuongTien: 0,
  BiDam: 0,
};
const PhuongThucGui = ["Khác", "Thoại", "Fax", "Email"];
const columns = [
  {
    field: "ThoiGianNhan",
    headerName: "Thời gian nhận",
    width: 130,
    renderCell: (params) =>
      params.getValue("ThoiGianNhan") !== null ? (
        <Moment format="DD-MM-yyyy HH:mm">
          {params.getValue("ThoiGianNhan")}
        </Moment>
      ) : (
        ""
      ),
  },
  {
    field: "NoiGui",
    headerName: "Nơi gửi",
    width: 230,
    renderCell: (params) => params.getValue("NoiGui"),
  },
  {
    field: "PhuongThucNhan",
    headerName: "Phương thức",
    width: 130,
    renderCell: (params) => PhuongThucGui[params.getValue("PhuongThucNhan")],
  },
  {
    field: "NoiDungNhan",
    headerName: "Nội dung",
    width: 200,
    renderCell: (params) => (
      <div className="cellNormal">{params.getValue("NoiDungNhan")}</div>
    ),
  },
  {
    field: "ThoiGianGui",
    headerName: "Thời gian gửi",
    width: 130,
    renderCell: (params) =>
      params.getValue("ThoiGianGui") !== null ? (
        <Moment format="DD-MM-yyyy HH:mm">
          {params.getValue("ThoiGianGui")}
        </Moment>
      ) : (
        ""
      ),
  },
  {
    field: "NoiNhan",
    headerName: "Nơi nhận",
    width: 230,
    renderCell: (params) => params.getValue("NoiNhan"),
  },
  {
    field: "PhuongThucGui",
    headerName: "Phương thức",
    width: 130,
    renderCell: (params) => PhuongThucGui[params.getValue("PhuongThucGui")],
  },
  { field: "NoiDungGui", headerName: "Nội dung", width: 200,
  renderCell: (params) => (
    <div className="cellNormal">{params.getValue("NoiDungGui")}</div>
  ),
 },
];
class SuKienTrucBanControl extends React.Component {
  constructor(props) {
    super(props);
    this.saveField = this.saveField.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.state = {
      canSaved: false, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorLog: "", //mo ta loi neu co
      //danh muc quoc gia
      loading_quoctich: true, // co dang loading danh muc quoc gia khong
      source_quoctich: [], //danh muc options cho quoc tich
      before:
        props.value === undefined
          ? {
              ThoiGian: new Date(),
            }
          : myLib.cloneObject(props.value), //thong tin truoc khi edit
          after:
          props.value === undefined
          ? defaultRecord
          : { ...defaultRecord, ...props.value }, //thong tin dang edit
      validateStatus: {},   
      dataRows: [], //danh sach ban ghi
    };
  }
  //ghi nhan gia tri nhap
  saveField = (fieldName, value) => {
    var old_changed = this.state.dataChanged;
    var s = this.state;
    s.after[fieldName] = value;
    s.dataChanged = !myLib.isSame(s.before, s.after, ['DuocCuu_NguoiVN', 'DuocCuu_NguoiNN', 'DuocCuu_GhiChu', 'TrucTiep_NguoiVN', 'TrucTiep_NguoiNN', 'TrucTiep_GhiChu', 'GianTiep_NguoiVN', 'GianTiep_NguoiNN', 'GianTiep_GhiChu', 'BiThuong', 'BiChet', 'MatTich', 'TrucTiep_PhuongTien', 'GianTiep_PhuongTien', 'BiDam']);
    s.canSaved = s.dataChanged;
    if(this.props.onChanged && old_changed != s.dataChanged) {
      this.props.onChanged(s.dataChanged);
    }
    this.setState(s);
  };
  //submit thong tin ve DB
  handleSave = () => {
    console.log(JSON.stringify(this.state.after));
    var check = sukienLayer.validate("ketqua", this.state.after);
    if (!check.error) {
      this.setState({ validateStatus: check, saving: true, errorLog: "" });      
      server
        .post(
          "sukien/saveKetQuaChiTiet",
          sukienLayer.chuanHoaSukien("ketqua", this.state.after)
        )
        .then((response) => {
          var before = {};
          var after = this.state.after;
          Object.assign(before, after);
          this.setState({
            before: before,
            after: after,
            dataChanged: false,
            canSaved: false,
            saving: false,
            errorLog: "",
          });
          //thong bao cho parent biet co data duoc saved
          if (this.props.onSaved) {
            this.props.onSaved(after);
          }
          if(this.props.onChanged) {
            this.props.onChanged(false);
          }
        })
        .catch((error) =>
          this.setState({ saving: false, errorLog: error + "" })
        );
    } else {
      this.setState({ validateStatus: check });
    }
  };
  loadDanhMuc() {
    //load danh muc tai nan
    server
      .query("trucban/GetBySuKien?mask=" + this.state.after.MaSK )
      .then((response) => {
        var danhsach = response;
        danhsach.map((item, index) => {
                item.id = index + 1;
              });
        this.setState({ dataRows: response });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_quoctich: false });
      });
  }
  //khi load component: load cac danh muc can thiet
  componentDidMount() {
    this.loadDanhMuc();
  }
  static getDerivedStateFromProps(props, state) {
    var newState = { ...state };
    //console.log("TaiNanControl props:", props.value);
    if (props.value !== undefined && props.value.MaSK !== state.after.MaSK) {
      //console.log("co su thay doi");
      //co su thay doi
      newState = {
        ...newState,
        after: { ...state.after, ...props.value },
      }; //lay thong tin tu parent form truyen vao thong qua props
    }
    //console.log("TaiNanControl new state:", newState);
    return newState;
  }
  render() {
    const { classes, theme } = this.props;
    return (
      <Accordion disabled={this.props.disabled} 
      defaultExpanded={this.props.value !== undefined}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          classes={{
            root: classes.normalPanel,
            expanded: classes.expandedPanel,
            content: classes.summaryContent
          }}
        >
          <Typography className={classes.heading}>Nhật ký xử lý của trực ban</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className={classes.divGrid}>
            <DataGrid
                rows={this.state.dataRows}
                columns={columns}
                id="TrucBanID"
                autoHeight
                className={classes.root}
                rowCount={this.state.dataRows.length}
                sortingMode="server"
                showCellRightBorder={true}
                showColumnRightBorder={true}
                hideFooter={true}
                menuContainerStyle={{ zIndex: 999 }}
                onCellClick={(params) => {
                  this.setState({
                    Editting_TrucBanID: params.data.TrucBanID,
                    Editting_ChieuDen: params.data.ChieuDen,
                  });
                }}
              />
            </div>
          </Grid>
            <Grid item xs={4}>
              {this.state.canSaved ? (
                <MyButton
                  onClick={this.handleSave}
                  color="primary"
                  text="Lưu"
                />
              ) : null}
            </Grid>
            <Grid item xs={10}>
              {this.state.saving ? (
                <CircularProgress />
              ) : this.state.errorLog === "" ? null : (
                this.state.errorLog
              )}
            </Grid>   
          </Grid>
        </AccordionDetails>
      </Accordion>
    );
  }
}
const styles = (theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  formControl: {
    marginTop: 2,
    minWidth: 120,
  },

  thoigian: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  textbox: {
    marginLeft: 1,
    marginRight: 1,
    width: "100%",
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  normalPanel: {
    backgroundColor: "lightskyblue",
    margin: 0,
    minHeight: 11,
  },
  expandedPanel: {
    backgroundColor: "skyblue",
    margin: 0,
    minHeight: '10px !important',
  },
  summaryContent: {
    margin: '1px !important',
  },
  normalLabel: {
    color: 'black',
  },
  redLabel: {
    color: 'red',
  } ,
  gridContainer: {
    height: 285,
  },
  divGrid: {
    height: 300,
  },
  root: {
    '& .MuiDataGrid-columnsContainer': {
      backgroundColor: theme.palette.type === 'light' ? '#eaeaea' : '#1d1d1d',
    },
  }
});
export default withStyles(styles, { withTheme: true })(
  SuKienTrucBanControl
);
